/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { Button } from '@styles/button.style'
import { ManageUserButtonStyle } from '@components/Button/ManagedUserButton/index.style'
import PopupUtils from '@utils/popup-utils'
import useRootStore from '@store/useRootStore'

export interface ManagedUserButtonProps {
  isVisible: boolean
  managedUserMyPageData: {
    iconImg: string;
    detailPopupImg: string;
  }
}

const ManagedUserButton: React.FC<ManagedUserButtonProps> = observer((props: ManagedUserButtonProps) => {
  const { managedUserMyPageData, isVisible } = props
  const { logStore } = useRootStore()

  const onClickManagedUserBtn = () => {
    // 마이페이지 블랙카드 버튼 로그
    logStore.writeButtonLog({ pageId: 'e010', buttonId: '014' }).catch(console.error)
    PopupUtils.showManagedUserDetailPopup({ popupImgUrl: managedUserMyPageData.detailPopupImg, title: "상세" })
  }

  return (
    <Fragment>
      {isVisible &&
        <Button TP className="managed-user-btn" css={ManageUserButtonStyle} onClick={onClickManagedUserBtn}>
          <img src={managedUserMyPageData.iconImg} alt="마이페이지 블랙카드 아이콘 버튼" loading="lazy"/>
        </Button>
      }
    </Fragment>
  )
})

export default ManagedUserButton
